const DATA = [
    {
       id:0,
       title:"IPhone 13",
       price:750,
       desc:"Nuestro sistema de dos cámaras más avanzado y un chip superrápido que deja atrás a la competencia.",
       img:"/assets/images/products/iphone13.png"		
    },
   {
       id:1,
       title:"IPhone 13 Pro",
       price:800,
       desc:"Un sistema de cámaras mucho más poderoso. Una pantalla con respuesta inmediata en cada interacción. El chip de smartphone más rápido del mundo. Un diseño increíblemente resistente. Y un gran salto en duración de batería.",
       img:"/assets/images/products/iphone13pro.jpg"		
    },
   {
       id:2,
       title:"IPhone 13 Pro Max",
       price:950,
       desc:"Un sistema de cámaras mucho más poderoso. Una pantalla con respuesta inmediata en cada interacción. El chip de smartphone más rápido del mundo. Un diseño increíblemente resistente. Y un gran salto en duración de batería",
       img:"/assets/images/products/iphone13promax.png"		
    },
    {
        id:3,
        title:"IPhone 14",
        price:750,
        desc:"Repleto de funcionalidades geniales.",
        img:"/assets/images/products/iphone14.jpg"		
     },
    {
        id:4,
        title:"IPhone 14 Plus",
        price:800,
        desc:"Definitivamente Extra Grande.",
        img:"/assets/images/products/iphone14plus.jpg"		
     },
    {
        id:5,
        title:"IPhone 14 Pro",
        price:950,
        desc:"iPhone 14 Pro. Se pasa de Pro.",
        img:"/assets/images/products/iphone14pro.jpg"		
     }
     ,
     {
      id:6,
      title:"IPhone 14 Pro Max",
      price:950,
      desc:"iPhone 14 Pro Max. Se pasa de Pro.",
      img:"/assets/images/products/iphone14promax.jpg"		
   }
   ,
     {
      id:7,
      title:"IPhone SE – 3ra Generación",
      price:950,
      desc:"Enamora por su poder. Conquista por su precio.Chip A15 Bionic superrápido. Una increíble duración de batería y una cámara que es una superestrella. Y además, el vidrio más resistente en un smartphone y botón de inicio con la seguridad de Touch ID.",
      img:"/assets/images/products/iphonese3.jpg"		
   }
   
   ]

export default DATA



